import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import ConfDtb from '../../../config/confDtb';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { dataProdi } from '../../../dummy-data/prodi';
import { dropdownAngkatan, dataMahasiswa } from '../../../dummy-data/mahasiswa';
import { dataTahunAkademik } from '../../../dummy-data/akademik';
const $ = require("jquery");
$.Datatable = require("datatables.net");

export default class CekKrsMahasiswa extends Component {
    state = {
        krsMahasiswa: [],
        prodi: [],
        angkatan: [],
        tahun_akademik: [],
        semester: [],
        sts: "",
        isLoad: false
    }

    changeInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    getAllData = () => {
        this.setState({
            prodi: dataProdi.map(p => ({ id_jurusan: p.prodi_id, nama_jurusan: p.prodi_nama })),
            angkatan: dropdownAngkatan.map(a => ({ id_angkatan: a.value, angkatan: a.label }))
        });
    }

    getTA = (e) => {
        this.setState({
            tahun_akademik: dataTahunAkademik.map(t => ({ thn_ajaran: t.tahun_akademik })),
            [e.target.name]: e.target.value
        });
    }

    execView = () => {
        // Filter mahasiswa based on criteria
        let filtered = [...dataMahasiswa];

        if (this.state.id_jurusan) {
            filtered = filtered.filter(m => m.prodi_id === parseInt(this.state.id_jurusan));
        }
        if (this.state.id_angkatan) {
            filtered = filtered.filter(m => m.angkatan === parseInt(this.state.id_angkatan));
        }

        // Map to expected format
        const mappedData = filtered.map(m => ({
            idcamaba: m.mhs_id,
            nim: m.nim,
            nama: m.nama,
            status: m.status,
            sts: 'Sudah pilih jadwal',
            statuskrs: 'Disetujui',
            kelas: 'Pagi',
            dosenwali: 'Dosen Wali Demo',
            koderpl: '-',
            keterangan: '-',
            jalur: 'Reguler'
        }));

        setTimeout(() => {
            this.setState({
                krsMahasiswa: mappedData,
                isLoad: false
            }, () => {
                ConfDtb();
            });
        }, 300);
    }

    getCekKrs = (e) => {
        e.preventDefault();
        this.setState({ isLoad: true });
        this.execView();
    }



    cetakAll = () => {
        document.getElementById("excelAll").click();
    }

    cetakBiasa = () => {
        document.getElementById("excelBiasa").click();
    }


    componentDidMount = () => {
        this.getAllData()
    }

    render() {
        return (
            <Fragment>
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-12 col-xl-8 mb-xl-0">
                            <p className="abu" style={{
                                fontSize: '15px', fontWeight: 'bold', color: '#999999',
                                textTransform: 'capitalize'
                            }}>
                                Akademik&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Cek KRS Mahasiswa
                            </p>
                        </div>
                    </div>
                </div>

                <div className="card card-custom mb-3 pl-3 pr-3">
                    <div className="card-body">
                        <form onSubmit={this.getCekKrs}>
                            <div className="row">
                                <div className="col-md-4 mb-2 mt-2">
                                    <select className="form-control selectCust" onChange={this.changeInput} name='id_jurusan' required>
                                        <option value="" hidden>- program studi -</option>
                                        {this.state.prodi.map((list, i) => {
                                            return (
                                                <option key={i} value={list.id_jurusan}>{list.nama_jurusan}</option>
                                            )
                                        })}
                                    </select>
                                </div>
                                <div className="col-md-4 mb-2 mt-2">
                                    <select className="form-control selectCust" name="id_angkatan" onChange={this.getTA}>
                                        <option value="" hidden>- angkatan -</option>
                                        {this.state.angkatan.map((list, i) => {
                                            return (
                                                <option key={i} value={list.id_angkatan}>{list.angkatan}</option>
                                            )
                                        })}
                                    </select>
                                </div>
                                <div className="col-md-4 mb-2 mt-2">
                                    <select className="form-control selectCust" required name="ta" onChange={this.changeInput}>
                                        <option value="" hidden>- tahun akademik -</option>
                                        {this.state.tahun_akademik.map((list, i) => {
                                            return (
                                                <option key={i} value={list.thn_ajaran}>{list.thn_ajaran}</option>
                                            )
                                        })}
                                    </select>
                                </div>
                                <div className="col-md-4 mb-2 mt-2">
                                    <select className="form-control selectCust"
                                        onChange={this.changeInput} name='smtta'
                                        required>
                                        <option value="" hidden>- semester -</option>
                                        <option value='1'>Ganjil</option>
                                        <option value='2'>Genap</option>
                                    </select>
                                </div>
                                <div className="col-md-4 mb-2 mt-2">
                                    <select className="form-control selectCust" required id="sts" name="sts" onChange={this.changeInput}>
                                        <option value="" hidden>- status pengajuan -</option>
                                        <option value="4">All</option>
                                        <option value="0">belum pengajuan</option>
                                        <option value="1">masih pengajuan</option>
                                        <option value="2">belum pilih jadwal</option>
                                        <option value="3">sudah pilih jadwal</option>
                                    </select>
                                </div>
                                <div className="col-md-4 mb-2 mt-2">
                                    <select className="form-control selectCust" required name='statusbayar' onChange={this.changeInput}>
                                        <option value="" hidden>- status bayar -</option>
                                        <option value="">-</option>
                                        <option value="N">belum bayar</option>
                                        <option value="Y">sudah bayar</option>
                                    </select>
                                </div>
                                <div className="col-md-12 mb-4 mt-4">
                                    <p align="right">
                                        <button className="btn btn-success btn-md" id="btn-sub" type="submit" style={{ borderRadius: '5px' }}
                                            disabled={this.state.isLoad ? true : false}
                                        >
                                            Cari Data
                                        </button>
                                    </p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="card card-custom">
                    <div className="card-body">
                        <p className="card-title text-center" style={{ fontSize: '25px', marginTop: '10px' }}>Cek Krs Mahasiswa</p>
                        {
                            this.state.isLoad ?
                                <div id="spinner" className="loader-1 colorful mt-5 mb-5">
                                    <div className="dot" />
                                    <div className="dot" />
                                    <div className="dot" />
                                </div>
                                : null
                        }
                        {
                            this.state.isLoad ? null :
                                <div id="konten">
                                    <div className='mt-3 mb-2'>
                                        {
                                            this.state.sts == "4" ?
                                                <p align="left">
                                                    <button className="btn btn-primary" onClick={this.cetakAll}>
                                                        <i className="fa fa-print" />
                                                        &nbsp; Cetak
                                                    </button>
                                                    <ReactHTMLTableToExcel
                                                        id="excelAll"
                                                        className="btn btn-primary sembunyi"
                                                        table="table2"
                                                        filename={`rekap-cek-krs`}
                                                        sheet="tablexls"
                                                        buttonText="Cetak" />
                                                </p>
                                                : null
                                        }
                                        {
                                            this.state.sts != "4" ?
                                                <p align="left">
                                                    <button className="btn btn-primary" onClick={this.cetakBiasa}>
                                                        <i className="fa fa-print" />
                                                        &nbsp; Cetak
                                                    </button>
                                                    <ReactHTMLTableToExcel
                                                        id="excelBiasa"
                                                        className="btn btn-success sembunyi"
                                                        table="table1"
                                                        filename={`rekap-cek-krs`}
                                                        sheet="tablexls"
                                                        buttonText="Cetak " />
                                                </p>
                                                : null
                                        }
                                    </div>
                                    <div className="table-responsive mt-3">
                                        <table id="tabel" className="display expandable-table table-striped" style={{ width: '100%' }}>
                                            <thead>
                                                <tr>
                                                    <th>No</th>
                                                    <th>NIM</th>
                                                    <th>Nama Mahasiswa</th>
                                                    <th>Status</th>
                                                    {
                                                        this.state.sts == 4 ? null :
                                                            <th>
                                                                Status KRS
                                                            </th>
                                                    }
                                                    <th>Kelas</th>
                                                    <th>Dosen Wali</th>
                                                    <th>RPL</th>
                                                    <th>Keterangan</th>
                                                    <th>Aksi</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.krsMahasiswa.map((list, i) => {
                                                        return (
                                                            <tr key={i}>
                                                                <td>{i + 1}</td>
                                                                <td>{list.nim}</td>
                                                                <td>{list.nama}</td>
                                                                <td><span class="badge bg-success">{list.status}</span></td>
                                                                {
                                                                    this.state.sts == "4" ? null : <td>{list.sts}</td>
                                                                }
                                                                <td><span class="badge bg-primary">{list.kelas}</span></td>
                                                                <td>{list.dosenwali}</td>
                                                                <td>{list.koderpl}</td>
                                                                <td>{list.keterangan}</td>
                                                                <td>
                                                                    <Link
                                                                        target={"_blank"}
                                                                        type="button"
                                                                        className="btn btn-primary ml-2 mt-1"
                                                                        to={`data-mahasiswa/biodata?id=${list.idcamaba}&nim=${list.nim}`}
                                                                        style={{ padding: "10px 15px 10px 15px", borderRadius: '5px' }}
                                                                            onClick={() => {
                                                                                localStorage.setItem('grub_id', this.props.grub_id);
                                                                            }}
                                                                    >
                                                                        detail
                                                                    </Link>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                        <br />
                                    </div>
                                </div>
                        }
                    </div>

                    {/* cetak excel biasa */}
                    <table id="table1" border='1' style={{ display: 'none' }}>
                        <center><h2>Data Cek KRS</h2> <br /></center>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>NIM</th>
                                <th>Nama Mahasiswa</th>
                                <th>Status</th>
                                <th>Status KRS</th>
                                <th>RPL</th>
                                <th>Keterangan</th>
                            </tr>
                        </thead>
                        <tbody id="data-table">
                            {
                                this.state.krsMahasiswa.map((list, i) => {
                                    return (
                                        <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td>{list.nim}</td>
                                            <td>{list.nama}</td>
                                            <td>{list.status}</td>
                                            <td>{list.statuskrs}</td>
                                            <td>{list.koderpl}</td>
                                            <td>{list.keterangan}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    {/* cetak excel biasa */}

                    {/* cetak excel all */}
                    <table id="table2" border='1' style={{ display: 'none' }}>
                        <center><h2>Data Cek KRS</h2> <br /></center>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>NIM</th>
                                <th>Nama Mahasiswa</th>
                                <th>Jalur</th>
                                <th>Dosen Wali</th>
                                <th>Status</th>
                                <th>RPL</th>
                                <th>Keterangan</th>
                            </tr>
                        </thead>
                        <tbody id="data-table">
                            {
                                this.state.krsMahasiswa.map((list, i) => {
                                    return (
                                        <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td>{list.nim}</td>
                                            <td>{list.nama}</td>
                                            <td>{list.jalur}</td>
                                            <td>{list.dosenwali}</td>
                                            <td>{list.status}</td>
                                            <td>{list.koderpl}</td>
                                            <td>{list.keterangan}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    {/* cetak excel all */}

                </div>
            </Fragment>
        );
    }
}
